import React from "react";

export default function PrintButton() {
  return <button className="print-button" onClick={() => window.print()}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -256 1792 1792" className="print-icon">
      <title>Print</title>
      <path d="M437.153 1270.237h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/>
    </svg>
    <span className="print-button-label">Print</span>
  </button>;
}




// WEBPACK FOOTER //
// ./modules/Common/components/svg/PrintButton.js